import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { spacing } from '../constants/spacing';
import { typography } from '../constants/typography';
import { useAppColors } from '../context/PreferencesContext';
import { AppButton } from './AppButton';

type Props = {
  title: string;
  message: string;
  actionTitle?: string;
  onAction?: () => void;
};

export function EmptyState({ title, message, actionTitle, onAction }: Props) {
  const palette = useAppColors();

  return (
    <View
      style={styles.container}
      accessibilityRole="summary"
      accessibilityLabel={`${title}. ${message}`}
    >
      <Text style={[styles.icon, { color: palette.textMuted }]}>○</Text>
      <Text style={[styles.title, { color: palette.textPrimary }]}>{title}</Text>
      <Text style={[styles.message, { color: palette.textSecondary }]}>
        {message}
      </Text>
      {actionTitle && onAction ? (
        <AppButton title={actionTitle} onPress={onAction} variant="secondary" />
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: { alignItems: 'center', gap: spacing.md, padding: spacing.xl },
  icon: { fontSize: 36 },
  title: {
    ...typography.sectionTitle,
    textAlign: 'center',
  },
  message: {
    ...typography.body,
    textAlign: 'center',
  },
});
